import { useEffect, useState } from 'react';
import { Form, Select, Spin } from 'antd';
import { providerCompanyService } from '@/services/providerCompany.service';
import { ProviderCompany } from '@/services/types/user.types';

interface ProviderSelectProps {
  name?: string;
  label?: string;
  required?: boolean;
  placeholder?: string;
}

export function ProviderSelect({
  name = 'providerId',
  label = 'Prestadora',
  required = true,
  placeholder = 'Selecione a prestadora',
}: ProviderSelectProps) {
  const [providers, setProviders] = useState<ProviderCompany[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProviders = async () => {
      setLoading(true);
      try {
        const data = await providerCompanyService.getAllProviders();
        setProviders(data);
      } catch {
      } finally {
        setLoading(false);
      }
    };

    fetchProviders();
  }, []);

  const options = providers.map((provider) => ({
    value: provider.id,
    label: provider.name,
  }));

  return (
    <Form.Item
      name={name}
      label={label}
      rules={required ? [{ required: true, message: 'Selecione uma prestadora' }] : []}
    >
      <Select
        showSearch
        placeholder={placeholder}
        optionFilterProp="label"
        options={options}
        loading={loading}
        notFoundContent={loading ? <Spin size="small" /> : 'Nenhuma prestadora encontrada'}
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
      />
    </Form.Item>
  );
}
